function applyHro301Rules(form) {
  const nextForm = JSON.parse(JSON.stringify(form));

  nextForm.pages.forEach((page) => {
    page?.parts?.forEach((part) => {
      let totalRemunerationField = null;
      let warningField = null;
      let waiveField = null;
      let waiveJustificationField = null;
      let natureField = null;

      part?.fields?.forEach((field) => {
        if (field.field_id === 'total_remuneration') {
          totalRemunerationField = field;
        }
        if (field.field_id === 'amount_300k_warning') {
          warningField = field;
        }
        if (field.field_id === 'waive_300k') {
          waiveField = field;
        }
        if (field.field_id === 'waive_justification') {
          waiveJustificationField = field;
        }
        if (field.field_id === 'nature') {
          natureField = field;
        }
      });

      const selectedNature = typeof natureField?.field_value === 'string'
        ? natureField.field_value.trim()
        : '';
      const isConsultancyWork = selectedNature === 'Consultancy Work';
      const totalAmount = Number(totalRemunerationField?.field_value || 0);
      const isOver300k = isConsultancyWork && !Number.isNaN(totalAmount) && totalAmount >= 300000;

      if (warningField) {
        warningField.field_invisible = !isOver300k;
      }

      if (waiveField) {
        waiveField.field_invisible = !isOver300k;

        if (!isOver300k) {
          delete waiveField.field_value;
        }
      }

      const waiveChecked = waiveField?.field_value === true;
      if (waiveJustificationField) {
        waiveJustificationField.field_invisible = !(isOver300k && waiveChecked);
        waiveJustificationField.field_mandatory = (isOver300k && waiveChecked) ? 'yes' : 'no';

        if (!(isOver300k && waiveChecked)) {
          delete waiveJustificationField.field_value;
        }
      }
    });
  });

  return nextForm;
}

function applyAaao201pRules(form) {
  const currentYear = new Date().getFullYear();
  const nextForm = JSON.parse(JSON.stringify(form));

  nextForm.pages.forEach((page) => {
    page?.parts?.forEach((part) => {
      part?.fields?.forEach((field) => {
        if (field?.field_id !== 'graduation_year') {
          return;
        }

        field.field_number_max = currentYear;

        if (field.field_value !== undefined && field.field_value !== null && field.field_value !== '') {
          const numericValue = Number(field.field_value);
          if (!Number.isNaN(numericValue) && numericValue > currentYear) {
            field.field_value = String(currentYear);
          }
        }
      });
    });
  });

  return nextForm;
}

const FORM_RULES = {
  HRO301: applyHro301Rules,
  HRO301V: applyHro301Rules,
  AAAO201P: applyAaao201pRules,
};

export function applyFormSpecificRules(form) {
  if (!form || !Array.isArray(form.pages)) {
    return form;
  }

  const formId = (form.id || '').toUpperCase();
  const rule = FORM_RULES[formId];

  if (!rule) {
    return form;
  }

  return rule(form);
}
